module.exports = __webpack_public_path__ + "static/media/82.e6f12500.png";